import { Link } from "wouter";

export default function TagChip({
  tag,
  active = false,
}: {
  tag: string;
  active?: boolean;
}) {
  return (
    <Link
      href={active ? "/blog" : `/blog?tag=${encodeURIComponent(tag)}`}
      className={`inline-flex rounded-full px-3 py-1 text-xs font-medium transition-colors ${
        active
          ? "bg-[#061525] text-[#D4FF00]"
          : "border border-[rgba(17,17,17,0.15)] text-[#666666] hover:border-[#061525]/40 hover:text-[#061525]"
      }`}
    >
      {tag}
    </Link>
  );
}
